import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Alert} from "reactstrap";
import _ from "lodash";
import ElementDisplay from "./ElementDisplay";
import {setSurveyNavVisibility} from "../../../../reducers/surveyNav/actions";
import {getCurrentMicroTime} from "../../../../reducers/timeMeasuring/actions";
import {FormattedMessage} from "react-intl";

class Conjoint extends Component {

  constructor(props){
    super(props);

    this.state = {
      elements: props.question.answers.map(answer => ({
        id: answer.id,
        betterThan: [], //element keys
        worseThan: [], //element keys
      })),
      leftElement: 0,
      rightElement: 1,
    };

    this.buildDetails = this.buildDetails.bind(this);
    this.getLeftElementAnswer = this.getLeftElementAnswer.bind(this);
    this.getRightElementAnswer = this.getRightElementAnswer.bind(this);
    this.getNextElements = this.getNextElements.bind(this);
  }

  componentDidMount() {
    this.props.setSurveyNavVisibility(false);
  }

  buildDetails(){
    const {elements} = this.state;

    const details = elements
    .map(element => {
      element.sum = element.betterThan.length;

      return element;
    })
    .sort((a, b) => (a.sum < b.sum) ? 1 : -1)
    .map((element, key) => {
      let detail = {
        answer: element.id,
        place: key+1,
        microTime: getCurrentMicroTime(this.props.startTime),
      }

      return detail;
    })

    this.props.onDetailsUpdated(details);
  }

  getLeftElementAnswer(){
    return this.props.question.answers.find(answer => answer.id === this.state.elements[this.state.leftElement].id);
  }

  getRightElementAnswer(){
    return this.props.question.answers.find(answer => answer.id === this.state.elements[this.state.rightElement].id);
  }

  /**
   * @param lastWinner = left/right
   */
  getNextElements(lastWinner){
    let elements = this.state.elements;
    let winnerElKey;
    let searchElKey;
    let winnerElValue;
    let searchElValue;

    if(lastWinner === 'left'){
      winnerElKey = 'leftElement';
      winnerElValue = this.state.leftElement;
      searchElKey = 'rightElement';
      searchElValue = this.state.rightElement;
    }else{
      winnerElKey = 'rightElement';
      winnerElValue = this.state.rightElement;
      searchElKey = 'leftElement';
      searchElValue = this.state.leftElement;
    }

    searchElValue++;
    const searchEl__startFrom = searchElValue;
    let isOverlap = false;
    while(!_.isNull(winnerElValue)){
      if(isOverlap && searchElValue >= searchEl__startFrom){
        winnerElValue = null;
        searchElValue = null;
        break;
      }

      if(searchElValue >= this.state.elements.length){
        searchElValue = 0;
        isOverlap = true;
      }
      if(searchElValue === winnerElValue){
        searchElValue++;
      }
      if(searchElValue >= this.state.elements.length){
        searchElValue = 0;
        isOverlap = true;
      }

      const result = this.checkElementsToCompare(elements, winnerElValue, searchElValue);
      elements = result.elements;

      if(result.valid){
        break;
      }

      searchElValue++;
    }

    if(_.isNull(winnerElValue) && _.isNull(searchElValue)){
      loop:
      for(let i = 0; i < elements.length; i++){
        for(let j = 0; j < elements.length; j++){
          if(i === j){
            continue;
          }

          const result = this.checkElementsToCompare(elements, i, j);
          elements = result.elements;

          if(result.valid){
            winnerElValue = i;
            searchElValue = j;

            break loop;
          }
        }
      }
    }

    this.setState({
      elements,
      [winnerElKey]: winnerElValue,
      [searchElKey]: searchElValue,
    }, () => {
      if(_.isNull(this.state.leftElement) && _.isNull(this.state.rightElement)){
        this.buildDetails();
      }
    })
  }

  checkElementsToCompare(elements, leftElement, rightElement){
    let valid = true;

    if(
      (
        elements[leftElement].betterThan.includes(rightElement)
        && elements[rightElement].worseThan.includes(leftElement)
      )
      || (
        elements[rightElement].betterThan.includes(leftElement)
        && elements[leftElement].worseThan.includes(rightElement)
      )
    ){
      valid = false;
    }else{
      let leftWin = _.intersection(elements[leftElement].betterThan, elements[rightElement].worseThan);
      if(leftWin.length > 0){
        valid = false;

        elements[leftElement].betterThan.push(rightElement);
        elements[rightElement].worseThan.push(leftElement);
      }else{
        let rightWin = _.intersection(elements[rightElement].betterThan, elements[leftElement].worseThan);

        if(rightWin.length > 0){
          valid = false;

          elements[rightElement].betterThan.push(leftElement);
          elements[leftElement].worseThan.push(rightElement);
        }
      }
    }



    return {
      elements,
      valid,
    }
  }

  validate(){
    const {details, question, validationTexts} = this.props;

    let validate = {
      valid: true,
      errors: []
    };

    validate.valid = _.isEmpty(validate.errors);
    return validate;
  }

  render() {
    const {leftElement, rightElement, elements} = this.state;

    if(_.isNull(leftElement) && _.isNull(rightElement)){
      this.props.setSurveyNavVisibility(true);

      return <Alert className="success text-center mb-0"><FormattedMessage id="question.conjoint.go"/></Alert>;
    }

    return (
      <div id="cj-elements" className="d-flex justify-content-around align-items-center flex-column flex-sm-row">
        <div
          className="cj-element cj-element-left"
          onClick={() => {
            this.setState({
              elements: elements.map((el, key) => {
                if(key === leftElement){
                  el.betterThan.push(rightElement);
                }
                if(key === rightElement){
                  el.worseThan.push(leftElement);
                }

                return el;
              })
            }, () => {
              this.getNextElements('left');
            })
          }}
        >
          <ElementDisplay answer={this.getLeftElementAnswer()} />
        </div>

        <div className="py-3 py-sm-0">VS</div>

        <div
          className="cj-element cj-element-right"
          onClick={() => {
            this.setState({
              elements: elements.map((el, key) => {
                if(key === rightElement){
                  el.betterThan.push(leftElement);
                }
                if(key === leftElement){
                  el.worseThan.push(rightElement);
                }

                return el;
              })
            }, () => {
              this.getNextElements('right');
            })
          }}
        >
          <ElementDisplay answer={this.getRightElementAnswer()} />
        </div>
      </div>
    );
  }
}

Conjoint.propTypes = {
  question: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
    }),).isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    answer: PropTypes.number.isRequired,
    place: PropTypes.number.isRequired,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  // validationTexts: PropTypes.shape({}).isRequired,
  intl: PropTypes.object.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, {setSurveyNavVisibility}, null, {withRef: true, forwardRef: true})(Conjoint);